module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAJJJREFUOI29lUESgCAIRb9ezYOlq071z2YbpzELCWNiozPwn4ioAACSmWTGovX60CZb85WUkgk86uPg3yyZDjAAQBAcaqaSJmgBFtiZoQWqxVyAmuDNgjegJGyjWpJHoADtTayvCJxApx0w9uFn+2fLrofi2jauje169VwfhxXYDBprrX0dTQ9siy03B8nd6ws4AFlkn0GUnIw/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/x-grey.png
// module id = 1615
// module chunks = 0